const MAX_QUANTITY_LIMIT = 99;

export { MAX_QUANTITY_LIMIT };
//# sourceMappingURL=constants.js.map
